export default "__VITE_ASSET__8a7c1b22__"